import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterSubCategory extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    return orderProducts.sort((a, b) => {
      const itemA = a.subCategory;
      const itemB = b.subCategory;

      if (itemA && itemB) {
        const itemAName = itemA.parent ? `${itemA.parent.name}${itemA.name}` : itemA.name;
        const itemBName = itemB.parent ? `${itemB.parent.name}${itemB.name}` : itemB.name;

        return itemAName?.localeCompare(itemBName);
      }
      return 0;
    });
  }
}

export default OrderProductsSorterSubCategory;
